import { nonInteraction } from "utils/analytics/funnel-utils"

export const ClientAccountAnalytics = {
    lk_login_current: nonInteraction({
        title: "Клиент нажал Войти на экране логина",
    }),
    lk_signup: nonInteraction({
        title: "Клиент нажал Зарегистрироваться на экране логина",
    }),
    lk_login_success: nonInteraction({
        title: "Клиент перешел в личный кабинет после авторизации",
    }),
    lk_canceled_sessions_watched: nonInteraction({
        title: "Клиент перешел на вкладку с отменёнными сессиями",
    }),
    lk_planned_sessions_watched: nonInteraction({
        title: "Клиент перешел на вкладку с запланированными сессиями",
    }),
    lk_pay_started: nonInteraction({
        title: "Клиент нажал Оплатить",
    }),
    lk_pay_confirmed: nonInteraction({
        title: "Клиент нажал Оплатить бронирование после перехода из Личного кабинета",
    }),
    lk_pay_success: nonInteraction({
        title: "Клиент оплатил сессию после перехода из Личного кабинета",
    }),
    lk_psy_profile: nonInteraction({
        title: "Клиент нажал на ссылку в профиль психолога",
    }),
    lk_session_map_offline: nonInteraction({
        title: "Клиент нажал на Как добраться",
    }),
    lk_session_map_online: nonInteraction({
        title: "Клиент нажал на Как подключиться",
    }),
    lk_reschedule_cancel_session_started: nonInteraction({
        title: "Клиент нажал на Перенести или отменить бронирование",
    }),
    lk_go_to_survey: nonInteraction({
        title: "Клиент нажал на Подобрать психолога в Личном кабинете",
    }),
    lk_login_app: nonInteraction({
        title: "Клиент нажал 'Войти в личный кабинет' в хедере",
    }),
}
